import { createContext } from 'react'

const Context = createContext({})

export const Consumer = Context.Consumer
export const Provider = Context.Provider

export default Context
